import React, { useEffect } from 'react';

const Download = () => {

  useEffect(() => {
    window.scrollTo(0,0)
    localStorage.clear();
  },[])
  
  return (
    <section>
      <h1>Download</h1>
    </section>
  )
}

export default Download;